export default "__VITE_ASSET__3PXi3GBi__"